export default "__VITE_ASSET__BBqMnEd4__"